import { render, staticRenderFns } from "./AddressWithStops.vue?vue&type=template&id=3b0d3a16&"
import script from "./AddressWithStops.vue?vue&type=script&lang=ts&"
export * from "./AddressWithStops.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports